import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRegistrationFlow } from '../hooks/useRegistrationFlow';
import { useAuth } from '../hooks/useAuth';

const RegistrationFlowManager: React.FC = () => {
  const { currentStep, registrationData, goToStep } = useRegistrationFlow();
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Ne pas interférer si l'utilisateur est déjà connecté
    if (user && !isLoading) {
      return;
    }

    // Vérifier si l'utilisateur est dans un processus d'inscription actif
    const savedStep = localStorage.getItem('registration_step');
    const savedData = localStorage.getItem('registration_data');

    // Ne rediriger que si l'utilisateur est dans un processus d'inscription actif
    // et qu'il n'est pas déjà sur la page d'authentification
    if (savedStep && savedData && savedStep !== 'auth') {
      const data = JSON.parse(savedData);
      
      // Vérifier que l'utilisateur n'est pas déjà sur la page d'authentification, landing page ou pages légales
      const currentPath = window.location.pathname;
      const isLegalPage = currentPath.startsWith('/legal') || 
                          currentPath.startsWith('/cgv') || 
                          currentPath.startsWith('/privacy') ||
                          currentPath.startsWith('/cgu');
      
      if (currentPath === '/' || currentPath === '/auth' || currentPath.startsWith('/auth/verify-email-waiting') || currentPath.startsWith('/pipeline') || isLegalPage) {
        return; // Ne pas rediriger si sur landing page, auth, pipeline ou pages légales
      }
      
      // Rediriger vers l'étape appropriée selon l'état
      switch (savedStep) {
        case 'email-verification':
          if (data.email) {
            navigate(`/auth/verify-email-waiting?email=${data.email}`);
          } else {
            goToStep('auth');
          }
          break;
          
        case 'plan-selection':
          // Plus de sélection de plan, aller directement à /pipeline
          navigate('/pipeline');
          break;
          
        case 'payment':
          // Plus de paiement, aller directement à /pipeline
          navigate('/pipeline');
          break;
          
        case 'api-access':
          navigate('/pipeline');
          break;
          
        default:
          goToStep('auth');
      }
    }
  }, [navigate, goToStep, user, isLoading]);

  return null; // Ce composant ne rend rien
};

export default RegistrationFlowManager;
